module.exports = __webpack_public_path__ + "static/media/cyber-antivirus.55281bc3.svg";